var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningMagnifyingGlass = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1584_970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9019 31.5654L20.6981 37.3617L16.3509 41.7089L10.5546 35.9126L14.9019 31.5654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9019 31.5654L20.6981 37.3617L16.3509 41.7089L10.5546 35.9126L14.9019 31.5654Z",
    fill: "#FF9800",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8161 31.773C41.1739 31.773 47.1385 25.8084 47.1385 18.4506C47.1385 11.0928 41.1739 5.12817 33.8161 5.12817C26.4583 5.12817 20.4937 11.0928 20.4937 18.4506C20.4937 25.8084 26.4583 31.773 33.8161 31.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8161 31.773C41.1739 31.773 47.1385 25.8084 47.1385 18.4506C47.1385 11.0928 41.1739 5.12817 33.8161 5.12817C26.4583 5.12817 20.4937 11.0928 20.4937 18.4506C20.4937 25.8084 26.4583 31.773 33.8161 31.773Z",
    fill: "#FF9800",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8161 31.773C41.1739 31.773 47.1385 25.8084 47.1385 18.4506C47.1385 11.0928 41.1739 5.12817 33.8161 5.12817C26.4583 5.12817 20.4937 11.0928 20.4937 18.4506C20.4937 25.8084 26.4583 31.773 33.8161 31.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8161 31.773C41.1739 31.773 47.1385 25.8084 47.1385 18.4506C47.1385 11.0928 41.1739 5.12817 33.8161 5.12817C26.4583 5.12817 20.4937 11.0928 20.4937 18.4506C20.4937 25.8084 26.4583 31.773 33.8161 31.773Z",
    fill: "#FF9800",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8597 5.407C39.6509 -1.80187 27.9823 -1.80279 20.7725 5.407C14.1986 11.9808 13.7305 22.0708 18.7782 29.14L16.3484 31.5698L15.6241 30.8455C15.2238 30.4453 14.5751 30.4453 14.1747 30.8455L1.49839 43.5219C-0.499463 45.5197 -0.499463 48.7705 1.49839 50.7683C3.49645 52.7662 6.74692 52.7662 8.74487 50.7683L21.4212 38.0921C21.8214 37.6919 21.8214 37.043 21.4212 36.6427L20.6968 35.9183L23.1267 33.4885C30.1983 38.5379 40.2876 38.0664 46.8597 31.4943C54.0685 24.2856 54.0696 12.6168 46.8597 5.407ZM7.2956 49.319C6.09688 50.5177 4.14648 50.5177 2.94777 49.319C1.74906 48.1203 1.74906 46.1699 2.94777 44.9711L14.8994 33.0195C20.584 38.7042 18.8047 36.9249 19.2473 37.3673L7.2956 49.319ZM19.2477 34.4691L17.7978 33.0192L20.0679 30.7489C20.5252 31.2588 20.9761 31.7131 21.5177 32.1987L19.2477 34.4691ZM45.4105 30.045C39.0027 36.4528 28.6306 36.4537 22.2219 30.045C15.8142 23.6374 15.8131 13.2652 22.2219 6.85638C28.6297 0.448492 39.0019 0.447672 45.4105 6.85638C51.8182 13.264 51.8193 23.6362 45.4105 30.045Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8597 5.407C39.6509 -1.80187 27.9823 -1.80279 20.7725 5.407C14.1986 11.9808 13.7305 22.0708 18.7782 29.14L16.3484 31.5698L15.6241 30.8455C15.2238 30.4453 14.5751 30.4453 14.1747 30.8455L1.49839 43.5219C-0.499463 45.5197 -0.499463 48.7705 1.49839 50.7683C3.49645 52.7662 6.74692 52.7662 8.74487 50.7683L21.4212 38.0921C21.8214 37.6919 21.8214 37.043 21.4212 36.6427L20.6968 35.9183L23.1267 33.4885C30.1983 38.5379 40.2876 38.0664 46.8597 31.4943C54.0685 24.2856 54.0696 12.6168 46.8597 5.407ZM7.2956 49.319C6.09688 50.5177 4.14648 50.5177 2.94777 49.319C1.74906 48.1203 1.74906 46.1699 2.94777 44.9711L14.8994 33.0195C20.584 38.7042 18.8047 36.9249 19.2473 37.3673L7.2956 49.319ZM19.2477 34.4691L17.7978 33.0192L20.0679 30.7489C20.5252 31.2588 20.9761 31.7131 21.5177 32.1987L19.2477 34.4691ZM45.4105 30.045C39.0027 36.4528 28.6306 36.4537 22.2219 30.045C15.8142 23.6374 15.8131 13.2652 22.2219 6.85638C28.6297 0.448492 39.0019 0.447672 45.4105 6.85638C51.8182 13.264 51.8193 23.6362 45.4105 30.045Z",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.7954,
    y: 9.58221,
    width: 3.78744,
    height: 11.3816,
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.7954,
    y: 9.58221,
    width: 3.78744,
    height: 11.3816,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.7954,
    y: 23.2106,
    width: 3.78744,
    height: 3.79386,
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.7954,
    y: 23.2106,
    width: 3.78744,
    height: 3.79386,
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1584_970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.2667,
    height: 52.2667,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningMagnifyingGlass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning-magnifying-glass.ab4895f7aa91a5882baa4e21b80062a8.svg";